<template>
  <div class="alert-container">
    <v-alert
      v-if="mostrarAlertaTemp"
      type="error"
      dismissible
      class="alert-item"
      @input="cerrarAlertaTemp"
    >
      Alarma horno activada por: {{ descripcion_temp }}
    </v-alert>

    <v-alert
      v-if="mostrarAlertaComb"
      type="error"
      dismissible
      class="alert-item"
      @input="cerrarAlertaComb"
    >
      Alarma horno activada por: {{ descripcion_comb }}
    </v-alert>
  </div>
</template>

<script>
import mqtt from 'mqtt'

export default {
  name: 'AlarmaGlobal',
  data() {
    return {
      descripcion_temp: '',
      mostrarAlertaTemp: false,
      cerradaTemp: false, // indica si el usuario cerró la alerta

      descripcion_comb: '',
      mostrarAlertaComb: false,
      cerradaComb: false
    }
  },
  created() {
    const client = mqtt.connect('wss://sakana.koiote.es:9002', {
      clientId: 'webclient_global_' + Math.random().toString(16).substr(2, 8),
      clean: false
    });

    client.subscribe('alarma_temp',{ qos: 2 })
    client.subscribe('alarma_comb',{ qos: 2 })

    client.on('message', (topic, message) => {
      const payload = JSON.parse(message.toString())

      if (topic === 'alarma_temp') {
        this.descripcion_temp = payload.descripcion

        if (payload.alarma == 1) {
          // Solo mostrar si no está cerrada
          if (!this.cerradaTemp) this.mostrarAlertaTemp = true
        } else if (payload.alarma == 0) {
          // Resetear el latch pero no cerrar la alerta automáticamente
          this.cerradaTemp = false
        }
      }

      if (topic === 'alarma_comb') {
        this.descripcion_comb = payload.descripcion

        if (payload.alarma == 1) {
          if (!this.cerradaComb) this.mostrarAlertaComb = true
        } else if (payload.alarma == 0) {
          this.cerradaComb = false
        }
      }
    })
  },
  methods: {
    cerrarAlertaTemp(val) {
      if (!val) this.cerradaTemp = true
      this.mostrarAlertaTemp = false
    },
    cerrarAlertaComb(val) {
      if (!val) this.cerradaComb = true
      this.mostrarAlertaComb = false
    }
  }
}
</script>

<style scoped>
.alert-container {
  position: fixed;
  top: 10%;
  left: 12%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  z-index: 2000;
  max-width: 400px;
  width: 90%;
}

.alert-item {
  width: 100%;
}
</style>
